import { useTranslation } from 'react-i18next'

import { Typography } from '@mui/material'

export const AccessDenied = () => {
  const { t } = useTranslation('main')
  return (
    <div className="center-screen">
      <Typography paragraph variant="h3">
        {t('common.alert.accessDenied')}
      </Typography>
    </div>
  )
}
